export const cpfMask = '###.###.###-##';
